import { Outlet } from "react-router";
import { SideMenu } from "./SideMenu";

export function BaseLayout() {
  return (
    <div className="d-flex gap-4 mt-3 mt-lg-0 h-100">
      <div className="d-none d-lg-block" style={{ minWidth: 300 }}>
        <SideMenu />
      </div>
      <div className="flex-fill mb-4">
        <Outlet />
      </div>
    </div>
  );
}
